import { Component, input } from "@angular/core";

import { StepModel } from "./model/step-model";
import { StepsStyleModel } from "./model/steps-style-model";
import { NgClass } from "@angular/common";

@Component({
  selector: "portal-steps",
  templateUrl: "./steps.component.html",
  standalone: true,
  styleUrls: ["./steps.component.scss"],
  imports: [NgClass],
})
export class StepsComponent {
  readonly stepsModels = input<StepModel[]>([]);
  readonly style = input<StepsStyleModel>({
    leadingColorCode: "",
  });
}
